import React from 'react';
import {
  Ban, X, ShieldOff, Calendar, AlertTriangle,
} from 'lucide-react';

/* -------------------------------------------------------------------------- */
/*                     Mapping motif → icône + couleur                        */
/* -------------------------------------------------------------------------- */
const REASON_VISUAL = {
  op_exempt:           { Icon: Ban,         cls: 'bg-amber-50 text-amber-700 border-amber-200',     short: 'Op exemptée' },
  op_cancelled:        { Icon: X,           cls: 'bg-slate-100 text-slate-600 border-slate-200',    short: 'Annulée' },
  client_disabled:     { Icon: ShieldOff,   cls: 'bg-violet-50 text-violet-700 border-violet-200',  short: 'Client désactivé' },
  out_of_scope_client: { Icon: Calendar,    cls: 'bg-rose-50 text-rose-700 border-rose-200',        short: 'Hors périm. client' },
  out_of_scope_global: { Icon: Calendar,    cls: 'bg-rose-50 text-rose-700 border-rose-200',        short: 'Hors périm. global' },
};

const FALLBACK = { Icon: AlertTriangle, cls: 'bg-slate-50 text-slate-600 border-slate-200', short: 'Exclue' };

/**
 * Badge unifié pour TOUS les motifs d'exclusion FNE.
 * Props : reason, label (optionnel — sinon dérivé du mapping), detail (tooltip)
 */
export const FneExclusionBadge = ({ reason, label, detail }) => {
  const v = REASON_VISUAL[reason] || FALLBACK;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-md border text-xs font-medium ${v.cls}`}
      title={detail || label || v.short}
      data-testid={`fne-exclusion-badge-${reason || 'unknown'}`}
    >
      <v.Icon className="w-3 h-3" />
      {label || v.short}
    </span>
  );
};

/**
 * Mini-puce compacte pour la colonne "Motif" du tableau d'exclusions.
 */
export const FneExclusionChip = ({ reason, detail }) => {
  const v = REASON_VISUAL[reason] || FALLBACK;
  return (
    <div className="flex items-start gap-1.5">
      <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-semibold ${v.cls}`}>
        <v.Icon className="w-2.5 h-2.5" />
        {v.short}
      </span>
      {detail && (
        <span className="text-[11px] text-slate-500 truncate max-w-[200px]" title={detail}>
          {detail}
        </span>
      )}
    </div>
  );
};
